import styled from 'styled-components';

export const HqoWheelPickerContainer = styled.div`
  margin-bottom: 32px;
`;
